import React from 'react';
import './LoadingState.css';

/**
 * LoadingState Component
 * 
 * Displays a loading indicator with optional message.
 * Provides better UX than generic "Loading..." text.
 * 
 * @param {string} message - Loading message to display
 * @param {boolean} fullScreen - Whether to take full screen height
 * @param {string} className - Additional CSS classes
 */
const LoadingState = ({ 
  message = "Loading...", 
  fullScreen = false,
  className = ""
}) => {
  return (
    <div className={`loading-state ${fullScreen ? 'loading-state-fullscreen' : ''} ${className}`}>
      <div className="loading-spinner" aria-hidden="true"></div>
      <span className="loading-message">{message}</span>
    </div>
  );
};

export default LoadingState;
